import {
  ComponentBuilder,
  FunctionComponent
} from '../../component-builder/types';
import { DisplayConfigType } from '../../../lib/config';
import { Component } from './component';

export class TagInjectorBuilder implements ComponentBuilder<DisplayConfigType> {
  isInjectable(adContext: AdContext, formatConfig: DisplayConfigType): boolean {
    return formatConfig?.tag != null;
  }

  build(adContext: AdContext, config: DisplayConfigType): FunctionComponent {
    return Component;
  }
}
